import { computed } from 'vue';
import { addDays, format } from 'date-fns';
import { Stripe } from 'stripe';

export default () => {
  const makeCheckoutSession = async (params?: Stripe.Checkout.SessionCreateParams) => {
    /**
     * Create a Checkout Session
     */
    return await useFetch(`/api/stripe/checkout/sessions`, {
      method: 'POST',
      body: params,
    });
  };

  // Computed property for today's date plus 30 days
  const datePlus30 = computed(() => {
    const resultDate = addDays(new Date(), 30);
    return format(resultDate, 'MMM. d, yyyy');
  });

  const datePlusX = (x: number) => {
    const resultDate = addDays(new Date(), x);
    return format(resultDate, 'MMM. d, yyyy');
  };

  // Computed property for today's date plus 365 days
  const datePlus365 = computed(() => {
    const resultDate = addDays(new Date(), 365);
    return format(resultDate, 'MMM. d, yyyy');
  });

  // returns today plus x days, in a unix timestamp
  const datePlusXInUnixTimestamp = (x: number): number => {
    const resultDate = addDays(new Date(), x);
    return Math.floor(resultDate.getTime() / 1000);
  };

  return {
    makeCheckoutSession,
    datePlus30,
    datePlus365,
    datePlusX,
    datePlusXInUnixTimestamp,
  };
};
